// extracted by mini-css-extract-plugin
export default {"fullWidth":"ui-z","hasStyledAspectRatio":"vi-z"};